import {
  OrganizationDashboardIcon,
  UserManagementIcon,
  BeaconLocationIcon,
} from '../components/common/Icons';

export const MENU_ITEMS = [
  {
    path: '/unit',
    copy: 'Organization Dashboard',
    Icon: OrganizationDashboardIcon,
    requiredRole: null,
  },
  {
    path: '/user-management',
    copy: 'User Management',
    Icon: UserManagementIcon,
    requiredRole: 'admin',
  },
  {
    path: '/beacon-location',
    copy: 'Beacon & Location',
    Icon: BeaconLocationIcon,
    requiredRole: null,
  },
];
